<template>
  <div id="app">
    <!-- <apploginheader></apploginheader> -->
    <router-view />
    <!-- <app-header></app-header> -->
    <!-- <app-fotter></app-fotter> -->
  </div>
</template>

<script>
import AppHeader from "./components/Header.vue";
import AppFotter from "./components/Fotter.vue";
import Apploginheader from "./components/loginheader.vue";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFotter,
    Apploginheader
  }
};
</script>

<style>
@import "./assets/public.css";
#app {
  min-height: 100%;
  height: auto !important;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue